import { aiEntitlementResource } from '@jira/router-resources__ai-entitlement/src/aiEntitlementResource.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { softwareCalendarEmbedRoute } from '@jira/router-routes__software-calendar-routes/src/softwareCalendarEmbedRoute.tsx';
import { CalendarEmbedSkeleton } from '@jira/platform__skeletons/src/ui/calendar/CalendarSkeleton.tsx';
import { getIssueViewResources } from '@jira/router-resources__issue-view/src/getIssueViewResources.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { calendarRouteEntry } from './common/calendarRouteEntry.tsx';

export const softwareCalendarEmbedRouteEntry: Route = createEntry(
	softwareCalendarEmbedRoute,
	() => ({
		group: 'software',
		skeleton: CalendarEmbedSkeleton,
		// eslint-disable-next-line no-restricted-syntax
		component: CalendarEmbedSkeleton,
		entryPoint() {
			return calendarRouteEntry;
		},
		layout: chromelessLayout,
		resources: [
			...getIssueViewResources(),
			// Delete when cleaning up jira-nav4-yurree-resources-cleanup
			resourceWithCondition(
				() => !fg('jira-nav4-yurree-resources-cleanup'),
				incidentExperimentTraitResource,
			),
			resourceWithCondition(
				() => !fg('jira-nav4-yurree-resources-cleanup'),
				// eslint-disable-next-line jira/router/no-project-context-resource
				projectContextResource,
			),
			resourceWithCondition(
				() => !fg('jira-nav4-yurree-resources-cleanup'),
				forgeProjectModuleResource,
			),
			resourceWithCondition(
				() => !fg('jira-nav4-yurree-resources-cleanup'),
				staticProjectSidebarNavigationResource,
			),
			resourceWithCondition(
				() => !fg('jira-nav4-yurree-resources-cleanup'),
				staticProjectSidebarConnectAddonsNavigationResource,
			),
			...jiraSpaResources(),
			resourceWithCondition(() => fg('ai_sprint_goal_gate'), aiEntitlementResource),
		],
		ufoName: 'next-gen-calendar-embed',
		EXPERIMENTAL__shouldReload: ({ context, prevContext, pluginId }) => {
			if (fg('dfo_connectedtoissueaggquery')) {
				if (pluginId === 'resources-plugin') {
					return (
						context.match.url !== prevContext.match.url ||
						(context.query.selectedIssue !== undefined &&
							context.query.selectedIssue !== prevContext.query.selectedIssue)
					);
				}

				return context.match.url !== prevContext.match.url;
			}
			return context.match.url !== prevContext.match.url;
		},
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
